import { FjModal, fjModalSizes } from 'components/primitives';
import type React from 'react';
import styled, { DefaultTheme } from 'styled-components';

const ModalHeader = styled.span`
  font-size: ${({ theme }) => theme.fontSizes.h5};
`;

interface ModalAttrsProps {
  theme: DefaultTheme;
  size?: string;
  dataTestId?: string;
}

const Modal = styled(FjModal).attrs(
  ({ theme, size, dataTestId }: ModalAttrsProps): Partial<React.ComponentProps<typeof FjModal>> => ({
    buttonFontSize: theme.fontSizes.buttonSmall,
    borderColor: theme.colors.selectableLightBg,
    titleWrapper: ModalHeader,
    size: size || fjModalSizes.SM,
    dataTestId,
  }),
)``;

export default Modal;
